module.exports = {
  "props": [
    {
      "name": "activatable",
      "type": "boolean",
      "default": "false",
      "source": "v-treeview-node",
      "description": {
        "en": "Allows user to mark a node as active by clicking on it",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "active-class",
      "type": "string",
      "default": "'v-treeview-node--active'",
      "source": "v-treeview-node",
      "description": {
        "en": "The class applied to the node when active",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "color",
      "type": "string",
      "default": "'primary'",
      "source": "colorable",
      "description": {
        "en": "Applies specified color to the control - it can be the name of material color (for example `success` or `purple`) or css color (`#033` or `rgba(255, 0, 0, 0.5)`). You can find list of built in classes on the [colors page](/styles/colors#material-colors).",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "expand-icon",
      "type": "string",
      "default": "'$subgroup'",
      "source": "v-treeview-node",
      "description": {
        "en": "Icon used to indicate that a node can be expanded",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "indeterminate-icon",
      "type": "string",
      "default": "'$checkboxIndeterminate'",
      "source": "v-treeview-node",
      "description": {
        "en": "Icon used when node is in an indeterminate state. Only visible when `selectable` is `true`.",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "item",
      "type": "object",
      "default": null,
      "source": "v-treeview-node",
      "description": {
        "en": "Item object used to build the node",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "item-children",
      "type": "string",
      "default": "'children'",
      "source": "v-treeview-node",
      "description": {
        "en": "Property on supplied `items` that contains its children",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "item-disabled",
      "type": "string",
      "default": "'disabled'",
      "source": "v-treeview-node",
      "description": {
        "en": "Property on supplied `items` that contains the disabled state of the item",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "item-key",
      "type": "string",
      "default": "'id'",
      "source": "v-treeview-node",
      "description": {
        "en": "Property on supplied `items` used to keep track of node state. The value of this property has to be unique among all items.",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "item-text",
      "type": "string",
      "default": "'name'",
      "source": "v-treeview-node",
      "description": {
        "en": "Property on supplied `items` that contains its label text",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "level",
      "type": "number",
      "default": "undefined",
      "source": "v-treeview-node",
      "description": {
        "en": "Property designating how deep the node is from the root of the treeview",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "load-children",
      "type": "function",
      "default": "null",
      "source": "v-treeview-node",
      "description": {
        "en": "A function used when dynamically loading children. If this prop is set, then the supplied function will be run if expanding an item that has a `item-children` property that is an empty array. Supports returning a Promise.",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "loading-icon",
      "type": "string",
      "default": "'$loading'",
      "source": "v-treeview-node",
      "description": {
        "en": "Icon used when node is in a loading state",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "off-icon",
      "type": "string",
      "default": "'$checkboxOff'",
      "source": "v-treeview-node",
      "description": {
        "en": "Icon used when node is not selected. Only visible when `selectable` is `true`.",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "on-icon",
      "type": "string",
      "default": "'$checkboxOn'",
      "source": "v-treeview-node",
      "description": {
        "en": "Icon used when leaf node is selected or when a branch node is fully selected. Only visible when `selectable` is `true`.",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "open-on-click",
      "type": "boolean",
      "default": "false",
      "source": "v-treeview-node",
      "description": {
        "en": "When `true` will cause nodes to be opened by clicking anywhere on it, instead of only opening by clicking on expand icon. When using this prop with `activatable` you will be unable to mark nodes with children as active.",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "parent-is-disabled",
      "type": "boolean",
      "default": "false",
      "source": "v-treeview-node",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "rounded",
      "type": "boolean",
      "default": "false",
      "source": "v-treeview-node",
      "description": {
        "en": "Provides an alternative active style for `v-treeview` node. Only visible when `activatable` is `true` and should not be used in conjunction with the `shaped` prop.",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "selectable",
      "type": "boolean",
      "default": "false",
      "source": "v-treeview-node",
      "description": {
        "en": "Will render a checkbox next to each node allowing them to be selected",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "selected-color",
      "type": "string",
      "default": "'accent'",
      "source": "v-treeview-node",
      "description": {
        "en": "The color of the selection checkbox",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "selection-type",
      "type": "string",
      "default": "'leaf'",
      "source": "v-treeview-node",
      "description": {
        "en": "Controls how the treeview selects nodes. There are two modes available: 'leaf' and 'independent'",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "shaped",
      "type": "boolean",
      "default": "false",
      "source": "v-treeview-node",
      "description": {
        "en": "Provides an alternative active style for `v-treeview` node. Only visible when `activatable` is `true` and should not be used in conjunction with the `rounded` prop.",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "transition",
      "type": "boolean",
      "default": "false",
      "source": "v-treeview-node",
      "description": {
        "en": "Applies a transition when nodes are opened and closed",
        "zh-Hans": "",
        "eo-UY": ""
      }
    }
  ],
  "mixins": [
    "colorable",
    "registrable-inject"
  ],
  "slots": [],
  "events": [],
  "functions": [],
  "name": "v-treeview-node",
  "sass": [],
  "component": true
}